// extracted by mini-css-extract-plugin
export var deliveryRow = "_p6-a";
export var fixedHeight = "_p6-4";
export var freightLogo = "_p6-9";
export var fullWidth = "_p6-3";
export var priceColumn = "_p6-5";
export var radioSelected = "_p6-7";
export var radioUnselected = "_p6-6";
export var selectedOption = "_p6-2";
export var selectedOptionContainer = "_p6-1";
export var selection = "_p6-0";
export var tallSkeletonText = "_p6-8";